export default {
  errors: {
    base_errors: {
      create_title: 'Creation failed',
      update_title: 'Update failed'
    },
    client: {
      base: {
        client_already_exists_add_sequential_id_to_update:
          'Client already exists, add sequential id column to associate',
        client_not_found_by_sequential_id: 'Client not found by sequential id',
        multiple_clients_with_same_name_add_sequential_id:
          'Multiple clients with same name, add sequential id column to associate'
      },
      city_invalid_for_dian: "City doesn't match with DIAN data",
      client_taxpayer_identification_number_invalid: "The customer's ID/RUC is not valid",
      client_phone_mobile_invalid: 'Phone mobile is not valid.',
      invalid_phone_mobile: 'Invalid phone mobile',
      invalid_phone_number: 'Invalid phone mobile',
      state_invalid_for_dian: "State doesn't match with DIAN data",
      taxpayer_identification_number: {
        greater_than:
          "Must enter the number without spaces or dashes. Must contain {{count}} character max. It can't start with 0.",
        maxLength:
          "Must enter the number without spaces or dashes. Must contain {{count}} character max. It can't start with 0.",
        pattern:
          "Must enter the number without spaces or dashes. Must contain {{count}} character max. It can't start with 0."
      }
    },
    client_reference: {
      not_found: 'Client with reference {{reference}} not found'
    },

    messages: {
      already_exist: 'Already exist',
      already_used_seal: 'Already used seal',
      api_key: {
        empty: 'Api Key cannot be blank',
        invalid: 'Invalid Api Key'
      },
      at_least_one_port: 'At least one port is required: SSH or Telnet',
      authorize_invoice_after_paid_must_be_disabled_if_has_dgo_subscription:
        'Must be disabled if the client has a Directv Go subscription',
      between: 'must be between {{first}} and {{last}}',
      blank: "can't be blank",
      body_length_without_variables: 'Body length is not valid',
      can_use_gateway_if_network: 'If the contract is Network, gateway cannot be used.',
      cannot_be_canceled_used_in_draft_invoice: 'Cannot be canceled. It is being applied to draft invoices.',
      cannot_be_destroyed: 'Cannot be destroyed.',
      cannot_be_destroyed_used_in_contracts: 'Cannot be destroyed. It is being applied to one or more contracts.',
      cannot_be_destroyed_used_in_draft_invoice: 'Cannot be destroyed. It is being applied to draft invoices.',
      cannot_be_modified_used_in_contracts: 'Cannot be modified. It is being applied to one or more contracts.',
      cannot_destroy_olt_with_contracts: 'Cannot destroy OLT with contracts',
      cannot_disable_radius_if_has_associated_nases: "You can't disable radius service if you have linked NAS",
      cannot_have_navigation_vlan: 'The VLAN already contains this value',
      cant_assign_coverage_with_olt_enabled: 'Cant assign coverage with OLT enabled',
      cant_be_a_past_date: 'Cant be a past date',
      cant_be_equal_to_time_from: 'Cant be equal to time from',
      cant_be_equal_to_time_to: 'Cant be equal to time to',
      cant_be_positive: 'Value cannot be positive.',
      cant_be_zero: 'Value cannot be zero.',
      cant_change_olt_with_contracts: 'Cant change OLT with contracts',
      cant_change_server_if_exist_full_nat: 'Cant change server if exist FULL-NAT',
      cant_remove_with_help_desk_issue_comments: 'Cannot be removed because it has comments in Help Desk tickets',
      cant_use_as_full_nat_if_has_forwarded_ports: 'Cant use as FULL-NAT, it has Forwarded Ports',
      cant_use_degraded_in_old_bmu: 'Degraded state is only available for Mikrotik or BMU version 0.7.3 onwards',
      cant_use_dhcp_without_mac: 'Cant use DHCP without a mac address',
      cant_use_dns_one_if_network: 'If the contract is Network, the first DNS cannot be used.',
      cant_use_dns_two_if_network: ' If the contract is Network, the second DNS cannot be used.',
      cant_use_rimpe_and_pyme: 'Microempresa and RIMPE cannot be activated at the same time.',
      cant_use_taxes_if_vat_condition_is_exempt: "Can't use taxes if vat condition is exempt",
      cant_use_this_service: 'Only can use one of the services: {{services}}',
      cant_use_this_service_if_is_single_host: 'Only can use this service is a host with /32',
      capacity_cant_be_less_than_contracts: 'The capacity cannot be less than the number of contracts',
      categories_ids_not_found: 'Categories do not exist',
      category_not_found: 'Category do not exist',
      client_item_tax_igv: 'Can only have a single tax of kind IGV and rate 18%',
      client_item_tax_peru_presence: 'Must have a tax of kind IGV',
      client_item_tax_peru_uniqueness: 'Must have only one IGV tax',
      client_must_have_iva_19_tax_if_has_dgo_subscription:
        'Client must have an IVA tax with rate 19% if has a Directv Go subscription',
      client_must_have_iva_21_tax_if_has_dgo_subscription:
        'Client must have an IVA tax with rate 21% if has a Directv Go subscription',
      client_must_have_peru_igv_18_tax_if_has_dgo_subscription:
        'Client must have an IGV tax with rate 18% if has a Directv Go subscription',
      client_not_found: 'Client not found',
      colombia_invalid_credentials: 'Invalid credentials',
      colombia_siigo_need_use_net_amount: 'To invoice with Siigo, you must use billing amounts as net values',
      connection_only_can_be_by_ssh: 'SSH port required',
      connection_only_can_be_by_telnet: 'Telnet port required',
      contract_discounts_cannnot_be_greater_than_discount_limit:
        'The sum of discounts percentages cannot be greater than 90%',
      contract_discounts_must_be_unique: 'Cannot add the same discount multiple times in progress.',
      contract_identifier_missing: 'Must select at least one contract identifier',
      contract_not_found: 'Contract not found',
      contracts: 'contracts',
      contracts_limit_reached: 'The subscription max contracts is reached, please update your subscription.',
      country_category_must_have_scope: 'You must select at least one country',
      dns_one_cant_be_blank: "First dns can't be blank",
      dns_one_cant_be_equal_to_dns_three: 'Can not be equal to the Third DNS server',
      dns_one_cant_be_equal_to_dns_two: 'Can not be equal to the Second DNS server',
      dns_three_cant_be_equal_to_dns_one: 'Can not be equal to the First DNS server',
      dns_three_cant_be_equal_to_dns_two: 'Can not be equal to the Second DNS server',
      dns_two_cant_be_equal_to_dns_one: 'Can not be equal to the First DNS server',
      dns_two_cant_be_equal_to_dns_three: 'Can not be equal to the Third DNS server',
      duplicated_entry: 'You cannot add duplicate values',
      duplicated_ip: 'Duplicated IP',
      ecuador: {
        taxpayer_identification_number:
          'Must enter the number without spaces or dashes. Must contain {{count}} character max.'
      },
      empty: "can't be empty",
      empty_translation: 'empty translation',
      error_fetching_data: 'Error fetching data',
      error_find_siigo_payment_way: 'Error when consulting the payment ways of Siigo',
      error_find_siigo_validation_setting: 'Error when consulting the Siigo setting',
      exact_number_lenght: 'does not have the correct length ({{count}} exact characters)',
      'execution expired': 'Timeout: execution expired',
      exist_another_contract_cable_modem_ip_with_the_same_ip: 'Exist another contract with the same cable modem IP.',
      exist_another_contract_with_the_same_ip: 'Exist another contract with the same IP.',
      failed_to_load_qr_try_again: 'Failed to load QR, try again',
      free_ports_must_be_greater_than_or_equal_to_not_assigned_contracts:
        'The number of free ports must be greater than or equal to the number of portless contracts associated with the NAP',
      from_day_cant_less_or_equal_than_from_day: 'to day cant be less or equal than from day',
      gateway_cant_be_blank: "Gateway can't be blank",
      greater_than: 'must be greater than {{count}}',
      greater_than_or_equal_to: 'must be greater than or equal to {{count}}',
      greater_than_rx_power_critical_lower: 'Value cannot be less than the Upper Critical Threshold.',
      greater_than_rx_power_warning_lower: 'The value cannot be less than the Lower Warning Threshold.',
      greater_than_rx_power_warning_upper: 'The value cannot be less than the Upper Warning Threshold.',
      identifier_missing: 'must select at least one identifier',
      inclusion: '{{value}} is invalid',
      interface_not_belongs_to_server: "The interface doesn't belongs to the contract server",
      invalid: 'is invalid',
      invalid_button_keys: 'Invalid button keys',
      invalid_credentials: 'Invalid credentials',
      invalid_date: 'Invalid date',
      invalid_fbp: 'Invalid FBP',
      invalid_for_dian: 'Required if invoicing firm is electronic',
      invalid_format_mx: 'Does not correspond to the RFC format',
      invalid_integration_keys: 'Invalid integration keys',
      invalid_phone_mobile: 'Invalid phone mobile',
      invalid_phone_number: 'Invalid phone mobile',
      invalid_pos_token: 'Invalid Sale point',
      invalid_private_key: 'Invalid private key',
      invalid_refresh_page: 'Unexpected error creating payment. Please try again.',
      invalid_select_option: 'Invalid option',
      invalid_suffix: 'Invalid number',
      invalid_url: 'invalid URL',
      invoice_already_paid: 'Invoice already paid',
      invoice_not_found: 'Invoice not found',
      invoice_void: 'Invoice is void',
      isNumber: "It's not a number",
      isp_category_must_have_scope: 'You must select at least one ISP',
      kind_taken: '"{{kind}} has already been taken',
      less_than: 'must be less than {{count}}',
      less_than_or_equal_to: 'must be less than or equal to {{count}}',
      maxLength: 'is too long (maximum is {{count}} characters)',
      mexico: {
        mexico_juridic: 'Legal entity. Valid format: Name - Creation date - Homoclave (maximum 12 characters).',
        mexico_natural: 'Individual. Valid format: Name - Date of birth - Homoclave (maximum 13 characters).'
      },
      //react-hook-form
      minLength: 'is too short (minimum is {{count}} characters)',
      missing_required_headers: 'Required headers are missing',
      multiple_clients_by_reference: 'Multiple clients found',
      multiple_invoices_found: 'Multiple invoices found',
      multiple_records_found: 'multiple records found',
      must_be_enabled_if_has_dgo_subscription: 'Must be enabled if the client has a Directv Go subscription',
      must_be_greater_than: 'must be greater than {{greater_than}}',
      must_enter_exactly_numbers: 'You must enter exactly {{number}} digits',
      must_have_invoice_provider: 'Must have invoice provider',
      //react-hook-form
      must_select_udp_or_tcp: 'Must select udp or tcp protocol at least one of them',
      must_use_electronic_if_has_dgo_subscription:
        'Must use electronic invoice if the cient has a Directv Go subscription',
      nap_port_not_exist: 'The port does not exist',
      nap_port_unavailable: 'Selected port is unavailable',
      need_to_save_in_current_account: 'You must save the change in the current account',
      needs_support_role: 'User needs to be support or admin to use public RSA',
      no_custom_negative: 'The value cannot be less than -35',
      no_payment_gateways: 'No payment gateways',
      not_a_number: 'is not a number',
      not_an_integer: 'must be an integer',
      not_enough_free_nap_ports_to_perform_capacity_decrease:
        'Not enough free NAP Ports to perform the capacity decrease',
      not_found: 'not found',
      not_found_ips: 'No IPs available',
      not_found_support: 'Something went wrong. Please try again',
      not_same_mikrotik: 'Not same Mikrotik',
      notification_mail_not_found: 'The closed ticket mail notification does not exist. Contact support.',
      ntp_server_one_cant_be_equal_to_ntp_server_two: 'Cant be equal to the Second NTP Server',
      ntp_server_two_cant_be_equal_to_ntp_server_one: 'Cant be equal to the First NTP Server',
      number_already_in_use: ' Number is already in use',
      numbers_must_be_correlative: 'Numbers must be correlative',
      only_letters_and_spaces_allowed: 'Only letters and spaces are allowed',
      only_network: ' Does not correspond to the network, the address associated with the network {{network}}',
      only_network_or_final_host: 'Only network or final host.',
      only_numbers_are_allowed: 'Only numbers are allowed',
      only_one_yape_gateway_per_isp: 'You can only have one Yape payment gateway',
      onts_consumption_not_available: 'Consumption graphs are not available',
      onts_consumption_requires_snmp_port: 'SNMP connection is required to see the consumption graphs.',
      orderable_already_has_pending_order_with_that_kind: 'You already have a pending order of this type.',
      pattern: 'is invalid',
      peru_client_must_have_address:
        'If you wish to invoice with an electronic legal name, you must specify an address.',
      peru_client_must_have_dni:
        'Must have DNI if client does not have RUC and wants to be issued final consumer invoices',
      plan_name_cant_use_especial_charts: `You may not use the following characters  ( / \\ " ' )`,
      power_limit_cant_be_greater_than_50_and_lower_than_negative_50:
        'The power limit cant be greater than 50 and lower than negative 50',
      ppp_profile_can_only_be_used_if_the_contract_has_pppoe_enabled:
        'The PPPoE Profile can only be used if the contract has PPPoE mode enabled.',
      private_port_already_assigned: 'Private port already assigned for this contract',
      profile_cant_be_blank:
        "The contract doesn't have an invoicing profile. Must update the contract and select an invocing profile.",
      profile_does_not_correspond_to_the_server_profiles:
        'The selected Profile does not correspond to the server profiles',
      prospect_does_not_have_plan: 'The Prospect does not have a plan.',
      provider_need_use_net_amount: 'To invoice with this provider, you must use billing amounts as net values',
      //react-hook-form
      public_ip_already_used: 'Public IP already used',
      public_port_already_assigned: 'Public port already asigned to another contract with the same provider',
      radius_or_acs_must_be_enabled: 'Radius or ACS must be enabled',
      reaction_not_found: 'Reaction does not exist',
      record_invalid: 'Validation failed: {{errors}}',
      record_not_found_in_invoice_service:
        'The invoicing firm could not be found in the invoice service. Contact support',
      required: 'must exist',
      restrict_dependent_destroy: {
        has_many: 'The record with dependent items cannot be deleted.',
        has_one: 'The record with dependent item cannot be deleted.'
      },
      rol_category_must_have_scope: 'You must select at least one role',
      service_error: 'Service not available, try later',
      service_not_available: 'Service not available',
      service_unavailable: 'Service not available',
      should_match: "doesn't match",
      // substitutionsAllowed: 'Some substitution is invalid',
      support: 'Something went wrong, please contact support.',
      taken: 'already taken',
      tickets: 'tickets',
      too_long: 'is too long (maximum is {{count}} characters)',
      too_short: 'is too short (minimum is {{count}} characters)',
      total_discounts_exceed_limit: 'The total discounts cannot exceed {{limit}}%',
      uniqueness_cable_modem_ip: 'A contract with the same cable modem ip already exist',
      uniqueness_ip: 'A contract with the same ip address already exist',
      unlink_ont_error: 'The ONU could not be unlinked from the contract. Please try again later.',
      user_not_found: 'User does not exist',
      user_notification_not_found: 'Notification does not exist',
      without_availability: 'Without availability',
      wrong_length: 'is the wrong length (should be {{count}} characters)',
      you_do_not_have_permission: 'You do not have permission.',
      you_must_select_a_qr: 'You must select a QR'
    },
    agent: {
      cannot_be_destroyed: "You cann't delete Box if you have Contracts or linked NAS",
      acs_access_url_invalid_format: 'It must include protocol, domain or IP, and port (e.g. http://ip:port)'
    },
    audit: {
      empty: 'empty'
    },
    contract: {
      interface_gpon: {
        invalid_format: 'Invalid format, the correct one is frame/board/port'
      },
      nap_id: {
        nap_should_belong_to_olt: 'Nap should belong to OLT',
        cant_have_nap_without_olt: 'Cant have nap without OLT',
        cant_assign_coverage_with_nap: 'Cant have nap if wireless node present'
      },
      nap_name: {
        nap_not_found: 'NAP does not exist',
        nap_should_belong_to_olt: 'Nap should belong to OLT',
        cant_have_nap_without_olt: 'Cant have nap without OLT'
      },
      nap_port_name: {
        cant_have_nap_port_without_nap: 'Must select a NAP',
        nap_port_not_found: 'Port does not exist'
      },
      fiber_code: {
        cant_have_seal_without_olt: 'Cant have seal without OLT',
        seal_not_found: 'Seal does not exist'
      },
      vlans_format: 'Enter numeric values between 2 and 4093 for all VLANs',
      address: {
        ip: { required: 'first choose a server', only_network_or_final_host: 'only_network_or_final_host' }
      },
      nas: {
        cannot_be_destroyed: "You cann't delete NAS if it's linked to a Box"
      },
      netmask: {
        pattern: 'Invalid netmask'
      },
      cable_modem_ip: {
        pattern: 'The address is invalid',
        exist_another_contract_cable_modem_ip_with_the_same_ip: 'Exist another contract with the same cable modem IP.'
      },
      cable_modem_gateway: {
        pattern: 'The address is invalid'
      }
    },
    invoicing: {
      discount: {
        must_be_before_expires_at: 'Must be before expiration date',
        must_be_after_starts_at: 'Must be after start date'
      },
      profile: {
        must_be_two_days_less: 'Must be at least 2 days less than the second due date ({{secondDue}}) days',
        must_be_less_to_25days:
          'It must be less than or equal to 25 if the second maturity date is at the end of the period.',
        must_be_zero_and_hundred: 'Must be a percentage between 0 and 100'
      }
    },
    invoice: {
      base: {
        paid_or_void: 'The invoice is already paid or void'
      }
    },
    invoicing_firm: {
      service_url: {
        pattern: 'invalid URL, must be something like: https://api.provider.com/v1/'
      },
      _prefix_peru_next_invoice_number_: {
        pattern: 'Must start with "F" and all others in uppercase, exact amount of 4 characters'
      },
      peru_next_invoice_credit_note_number: {
        pattern: 'Must start with F and must be at least 4 characters'
      },
      _prefix_peru_next_final_consumer_invoice_number_: {
        pattern: 'Must start with B and must be at least 4 characters long'
      },
      _prefix_peru_next_final_consumer_invoice_credit_note_number_: {
        pattern: 'Must start with B and must be at least 4 characters long'
      }
    },
    license: {
      hola_suite: {
        invalid_format_api_login: 'Enter a valid URL (domain)',
        url_service_or_token_invalid: 'You must enter a valid URL and Token'
      }
    },
    nap: {
      first_olt: 'You must choose an olt.',
      fbp: 'Enter a valid format (example: n°/n°/n°)',
      kingtype_format: 'Please enter a valid GPON port format (example: g01/01).',
      huawei_format: 'Please enter a valid Frame/Board/Port format. Port between 0 and 15.',
      default_format: 'Please enter a valid Frame/Board/Port format. Port between 1 and 16.'
    },
    nap_port: {
      name: {
        taken: 'port name alredy taken'
      }
    },
    notification_sms: {
      body: {
        substitutionsAllowed: 'Some substitution is invalid'
      }
    },
    orders: {
      order: {
        end_at_greater_than_start_at: 'End date must be greater than start date',
        invalid_images_format: 'The following images have an invalid format: {{filenames}}',
        start_at_greather_than_today: 'Start date must be greater than today'
      }
    },
    payment: {
      base: {
        invoicing_client_mismatch: 'The invoice belongs to a different client'
      }
    },
    tv_services: {
      directv_go: {
        cannot_be_modified: 'The value cannot be modified since there are subscriptions using this pack',
        client_must_use_colombia_siigo: 'Client must use electronic invoice with Siigo',
        client_must_use_electronic_invoice: 'Client must use electronic invoice',
        client_must_have_invoicing_enabled: 'Client must have invoicing enabled',
        client_must_not_authorize_invoice_after_paid: 'Client must have authorize invoice after paid disabled',
        client_must_have_iva_19_tax: 'Client must have an IVA tax with rate 19%',
        client_must_have_iva_21_tax: 'Client must have an IVA tax with rate 21%',
        client_must_have_peru_igv_18_tax: 'Client must have an IGV tax with rate 18%',
        must_be_first_of_upcoming_months: 'Must be first of an upcoming month',
        must_have_one_active_basic_pack: 'Must have one active basic plan',
        must_have_one_active_pack: 'Must have one active plan',
        must_have_only_one_basic_pack: 'Must have only one basic plan',
        must_have_only_one_of_each_pack: 'Must have only one of each plan',
        must_select_a_basic_plan: 'Must select a basic plan',
        must_reactivate_account_to_update_packs: 'Must reactivate the subscription to update th packs',
        must_wait_until_next_month_to_change_basic_pack: 'Must wait until next month to change a basic plan',
        invalid_mail_format: 'Please enter a valid email address',
        invalid_name_format: 'Please enter a valid name',
        invalid_last_name_format: 'Please enter a valid last name'
      }
    },
    helpdesk: {
      issue: {
        must_select_a_main_or_secondary_category: 'Must select a main or secondary category',
        expires_at_more_than_or_equals_to_date_today: 'Expires at must be more than or equals to today'
      }
    },
    hola_notification: {
      automatic_notifications: {
        channels: {
          must_select_channel: 'Must select a Channel'
        }
      }
    },
    payment_gateway: {
      must_enter_last_8_digits: 'Must enter the last 8 digits of the reference'
    },
    plan: {
      burst_limit_down_human: {
        must_be_greater_than: 'must be greater than {{string}}'
      },
      burst_limit_up_human: {
        greater_than_or_equal_to: 'must be greater than or equal to {{string}}'
      },
      burst_threshold_down_human: {
        greater_than_or_equal_to: 'must be greater than or equal to {{count}}',
        must_be_less_than: 'Must be less than or equal to Max. burst {{string}}, or equal to zero'
      },
      burst_threshold_up_human: {
        greater_than_or_equal_to: 'must be less than or equal to {{count}}',
        must_be_less_than: 'Must be less than or equal to Max. burst {{string}}, or equal to zero'
      },
      error_week: 'At least must choose one day',
      time_from: {
        maxLength: 'is invalid',
        minLength: 'is invalid',
        required: "can't be blank",
        validate: 'Cannot be equal to the time of completion'
      },
      time_to: {
        maxLength: 'is invalid',
        minLength: 'is invalid',
        required: "can't be blank",
        validate: 'Cannot be the same as the start time'
      }
    },
    portal_configuration: {
      mobile_phone: { minLength: 'Invalid Phone Number' },
      phone: {
        minLength: 'Invalid Phone Number'
      },
      subdomain: {
        maxLength: 'is too long (maximum {{value}} characters)'
      }
    },
    ppp_profile: {
      dhcpv6_pd_pool: {
        required: 'first choose a server'
      },
      remote_ipv6_prefix_pool: {
        required: 'first choose a server'
      },
      local_address: {
        pattern: 'must be an ip'
      },
      mikrotik_dns_server_one: {
        pattern: 'must be an ip',
        validate: 'the ip must be different'
      },
      mikrotik_dns_server_three: {
        pattern: 'must be an ip',
        validate: 'the ip must be different'
      },
      mikrotik_dns_server_two: {
        pattern: 'must be an ip',
        validate: 'the ip must be different'
      }
    },
    smtp_configuration: {
      port: {
        pattern: 'must be greater than 0'
      }
    },
    sale_desk: {
      lead: {
        at_least_one_contact_attr: 'Must provide at least one contact method.',
        invalid_phone_mobile: 'Invalid phone mobile',
        invalid_phone_number: 'Invalid phone mobile'
      },
      tags: {
        pattern: 'Color must be a valid HEX code (e.g. #FFF or #FFFFFF)'
      },
      ticket: {
        invalid_attachments_format: 'The following attachments have an invalid format: {{filenames}}'
      }
    },
    seal: {
      end_range_validate: 'The end value cannot be less than or equal to the start value.',
      minimun_quantity_batch_seals: 'The minimum quantity to create a batch is 50 seals.',
      maximun_quantity_batch_seals: 'The maximum quantity to create a batch is 1000 seals.',
      only_numbers: 'Please, enter an interger number.',
      start_range_validate: 'The start value cannot be greater than or equal to the end value.',
      cannot_be_less_than_0: "Can't be less than 0."
    },
    sentry: {
      errorFormEntry: 'Some fields were invalid. Please correct the errors and try again.',
      errorGeneric: 'An unknown error occurred while submitting your report. Please try again.',
      labelClose: 'Close',
      labelComments: 'What happened?',
      labelEmail: 'Email',
      labelName: 'Name',
      labelSubmit: 'Submit',
      subtitle: 'Our team has been notified.',
      subtitle2: "If you'd like to help, tell us what happened below.",
      successMessage: 'Your feedback has been sent. Thank you!'
    },
    service_invoice: {
      from_day_cant_less_or_equal_than_from_day: 'to day cant be less or equal than from day'
    },
    networking_form: {
      nap_without_olt:
        'The NAP {{nap_name}} assigned to the prospect does not have an associated OLT. If you want to use the network form, associate the NAP with the corresponding OLT. Otherwise, ',
      use_contract_form: 'use the contract form.',
      prospect_without_plan:
        'The prospect does not have a plan. If you want to use the network form, associate a plan to the prospect. Otherwise, '
    }
  }
};
